import React, {useContext, useEffect, useState} from 'react';
import {Button, Form, FormInstance, Input, Modal, Space, Spin} from 'antd';
import {observer} from "mobx-react-lite";
import {StoreContext} from "../../../store.context";
import {Translate} from "../../util/translation.util";
import {Translation} from "../../../types/modules";
import { LoadingOutlined } from '@ant-design/icons';
import TextArea from "antd/lib/input/TextArea";

/**
 * Authorization check would be easier, right now waiting for this feature
 * https://github.com/remix-run/react-router/discussions/9564
 */
const TranslateModal: React.FC = observer(() => {
    const formRef = React.createRef<FormInstance>();

    const {
        appStore: {
            updateApplicationTranslations,
            activeTranslatorModeTranslation,
            activeTranslatorModeTranslationLoading,
            setActiveTranslatorModeTranslation,
            invalidateTranslationCache,
            saveTranslation
        },
    } = useContext(StoreContext);

    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [invalidateConfirmLoading, setInvalidateConfirmLoading] = useState(false);

    useEffect(() => {
        setOpen(!!activeTranslatorModeTranslation || activeTranslatorModeTranslationLoading);

        if (activeTranslatorModeTranslation) {
            formRef.current?.setFieldsValue(activeTranslatorModeTranslation);
        }
    }, [activeTranslatorModeTranslation, activeTranslatorModeTranslationLoading, formRef]);

    const onFinish = async (values: any) => {
        setConfirmLoading(true);

        await saveTranslation(values)
                .then(() => {
                    setOpen(false);
                    setConfirmLoading(false);
                    setActiveTranslatorModeTranslation(null);
                })
    }

    const saveAndInvalidate = async () => {
        let values = formRef.current?.getFieldsValue();
        setInvalidateConfirmLoading(true);

        await saveTranslation(values)
            .then(async () => {
                await invalidateTranslationCache()
                    .then(async () => {
                        await updateApplicationTranslations()
                            .then(() => {
                                setOpen(false);
                                setInvalidateConfirmLoading(false);
                                setActiveTranslatorModeTranslation(null);
                            });
                    });
            });
    }

    const layout = {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
        style: { padding: 16, paddingBottom: 0 }
    };

    const loadingIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

    return ( <Modal
            title={<Translate message={`global.modal.title.edit_translation`} />}
            open={open}
            confirmLoading={confirmLoading}
            onCancel={() => {
                setActiveTranslatorModeTranslation(null);
                setOpen(false);
            }}
            footer={null}
        >
            {
                (activeTranslatorModeTranslationLoading && !activeTranslatorModeTranslation) ? (
                    <Spin indicator={loadingIcon}>
                        <div style={{ padding: '50px 100px', borderRadius: '4px' }} className="content" />
                    </Spin>
                ) : (
                    <Form ref={ formRef } {...layout} initialValues={activeTranslatorModeTranslation as Translation} onFinish={onFinish}>
                        <Form.Item hidden={true} name={'_id'}>
                            <Input />
                        </Form.Item>
                        <Form.Item name={'_key'} label={`Key`}>
                            <TextArea disabled={true} />
                        </Form.Item>
                        <Form.Item name={'_domain'} label={`Domain`}>
                            <TextArea disabled={true} />
                        </Form.Item>
                        <Form.Item name={'en'} label={`EN`}>
                            <TextArea />
                        </Form.Item>
                        <Form.Item name={'nl'} label={`NL`}>
                            <TextArea />
                        </Form.Item>

                        <Space direction={`horizontal`} style={{ width: '100%', justifyContent: 'right' }}>
                            <Button type="primary" htmlType={`submit`} loading={confirmLoading}>
                                <Translate message={`global.button.save`} />
                            </Button>

                            <Button type="primary" loading={invalidateConfirmLoading} onClick={async () => { await saveAndInvalidate() }}>
                                <Translate message={`global.button.save_and_invalidate`} />
                            </Button>
                        </Space>
                    </Form>
                )
            }
        </Modal>
    )
});

export default TranslateModal;